export default __webpack_public_path__ + "3513fa0dae71098c8ff1be22dba46ea4.png";